module.exports = __webpack_public_path__ + "img/AutoDeleteOutlined.00a0a685.svg";